<template>
    <v-app-bar fixed>
        <template v-if="responsive">
            <div  class="logo-space default">
                <a href="/" target="_blank">
                    <v-img :src="logoImage" width="162" />                
                </a>                  
            </div>

            <div class="v-toolbar-title">                    
                <v-toolbar-title>
                    <v-btn class="default v-btn--simple" dark icon @click="toggleMenu">
                        <v-icon>mdi-view-list</v-icon>
                    </v-btn>

                    <span v-if="!responsiveRemoveItens" translate="no">
                        {{title}}         
                    </span>
                </v-toolbar-title>                 
            </div>
        </template>

        <template v-if="!responsive && !getDrawer">
            <div class="logo-space default">
                <a href="/" target="_blank">
                    <v-img :src="logoImage" width="162" />                
                </a>                  
            </div>         

            <v-toolbar-title>
                <v-btn class="default v-btn--simple" dark icon @click="toggleMenu">
                    <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <span v-if="!responsiveRemoveItens">
                    {{title}}         
                </span>
            </v-toolbar-title>              
        </template>

        <template  v-if="!responsive && getDrawer">
            <v-toolbar-title class="v-toolbar-spaced">
                <v-btn class="default v-btn--simple" dark icon @click="toggleMenu">
                    <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <span v-if="!responsiveRemoveItens">
                    {{title}}         
                </span>
            </v-toolbar-title>              
        </template>        

        <v-spacer />

        <v-toolbar-items>
            <v-flex layout py-2>
                <v-btn to="/" v-if="!responsiveHideHome" class="default v-btn--simple" dark icon >                        
                    <v-icon color="tertiary">mdi-home</v-icon>
                </v-btn>

                <v-menu bottom content-class="dropdown-menu" offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }" class="toolbar-items" >
                        <v-btn class="default v-btn--simple" dark icon v-on="on">                        
                            <v-badge color="error" overlap>
                                <template slot="badge">
                                    {{ notifications.length }}
                                </template>

                                <v-icon color="tertiary">mdi-bell</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    
                    <v-card v-show="notifications.length > 0">
                        <v-list>
                            <v-list-item v-for="(notification, index) in notifications" :key="index">
                                <v-list-item-title>
                                    {{notification.text}}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>          

                <v-menu v-if="!responsiveRemoveItens" bottom content-class="dropdown-menu" offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }" class="toolbar-items" >
                        <v-btn class="default v-btn--simple" dark icon v-on="on">                        
                            <flag :iso="selectedFlag" />
                        </v-btn>
                    </template>
                    
                    <v-card>
                        <v-list>
                            <v-list-item v-for="(flag, index) in availableFlags" :key="index">
                                <v-list-item-title @click="onChangeLanguage(flag)">
                                    <flag :iso="flag"/>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                <v-btn to="/logout" class="default v-btn--simple" dark icon>                        
                    <v-icon>mdi-logout</v-icon>
                </v-btn>                
            </v-flex>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
import Vue from 'vue'
import FlagIcon from 'vue-flag-icon'

import ResponsivenessMixin from '@/mixin/responsiveness'
import PaisConstante from '@/constants/corporativo/pais.js'
import { mapGetters, mapMutations } from 'vuex'

Vue.use(FlagIcon);

export default {
    mixins: [ ResponsivenessMixin ],  
    data: () => ({
        flags: [
            "br",
            "us",
            "es"           
        ],
        title: null,
        responsiveRemoveItens: false,
        responsiveHideHome: false,
        selectedFlag: null,
        notifications: [ ],
        logoImage: require("@/assets/logo_sonda_branco.png")
    }),
    watch: {
        '$route' (val) {
            this.title = val.meta.title;
        }
    },
    created(){
        const cached = window.localStorage.getItem("drawer");
        if(cached != null) this.setDrawer(eval(cached))  

        if(this.$locale == null){
            let country = this.getUserCountry;
            if(country == null){
                const handler = window.setInterval(
                    () => {
                        country = this.getUserCountry;
                        if(country == null) return;
                        
                        this.setFlagByCountry(country);

                        window.clearInterval(handler);
                    }, 
                    100
                )
            }    
            else{
                this.setFlagByCountry(country);
            }
        }
        else {
            this.setFlag(this.$locale);
        }
    },
    computed: {
        ...mapGetters("app", ["getDrawer", "getUserCountry"]),
        availableFlags(){
            return this.flags.filter(f => f != this.selectedFlag);
        }
    },
    methods: {
        ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
        toggleMenu () {
            this.setDrawer(!this.getDrawer)
        },
        setFlag(locale){
            this.$locale = locale;
            switch(locale){
                case process.env.VUE_APP_DB_LOCALE_ES:
                    this.selectedFlag = "es";
                    break;

                case process.env.VUE_APP_DB_LOCALE_EN:
                    this.selectedFlag = "us";
                    break;

                default:
                    this.selectedFlag = "br";
                    break;                    
            }
        },        
        setFlagByCountry(country){
            switch(country.codigoSuccessFactors){
                case PaisConstante.brasil.codigo:
                    this.selectedFlag = "br";
                    this.$locale = process.env.VUE_APP_DB_LOCALE_PTBR;

                    break;

                case PaisConstante.estadosUnidos.codigo:
                    this.selectedFlag = "en";
                    this.$locale = process.env.VUE_APP_DB_LOCALE_EN;

                    break;

                default:
                    this.selectedFlag = "es";
                    this.$locale = process.env.VUE_APP_DB_LOCALE_ES;

                    break;                            
            }
        },
        onChangeLanguage (flag) {
            switch(flag){
                case "br":
                    this.setFlag(process.env.VUE_APP_DB_LOCALE_PTBR);
                    break;    

                case "us":
                    this.setFlag(process.env.VUE_APP_DB_LOCALE_EN);
                    break; 

                default:
                    this.setFlag(process.env.VUE_APP_DB_LOCALE_ES);
                    break;
            }
        },
        onResponsiveInverted () {
            this.responsiveRemoveItens = false;
            this.responsiveHideHome = false; 

            if(window.innerWidth < 600) 
                this.responsiveRemoveItens = true;

            if(window.innerWidth < 368) 
                this.responsiveHideHome = true;
        }
    }
}
</script>

<style lang="scss" scoped> 
@import "../../styles/material-dashboard/variables";

</style>
